import {Hcp} from "@/pages/common/Home/Suit/Hcp";
import {Intro} from "@/pages/common/Home/Suit/Intro";
import {RotateCards} from "@/pages/common/Home/Suit/RotateCards";
import {Try} from "@/pages/common/Home/components/Try";

import {usePopup} from "@layouts/popup/InfoPopup/PopupContext";
import {PresentationPopup} from "@popups/requestPopups/PresentationPopup";
import {Helmet} from "react-helmet";
import {useTranslation} from "react-i18next";

import styles from "./styles.module.scss";

export const Suit = () => {
  const {openPopup} = usePopup();
  const {t} = useTranslation();

  const handleOpenPopup = () => {
    openPopup(<PresentationPopup />);
  };

  return (
    <>
      <Helmet title={t("head_title.suit")} />

      <div className={"container-big"}>
        <div className={styles.suit_page}>
          <Intro />

          <div className={"container-home"}>
            <Try
              size={35}
              title={
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.suit.try"),
                  }}
                />
              }
              button={
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.suit.try_btn"),
                  }}
                />
              }
              onClickBtn={handleOpenPopup}
            />
          </div>

          <div className={"container-home"}>
            <RotateCards />
          </div>

          <div className={"container-home"}>
            <Hcp />
          </div>
        </div>
      </div>
    </>
  );
};
